<script setup lang="ts">
  import { RouterLink } from 'vue-router'
  import ButtonQC from '@qicgroupdoha/qic-connect-ds/components/ButtonQC'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import { InboundFlowRoutes, OutboundFlowRoutes } from '@/shared/types/router.types'
</script>

<template>
  <WrapperQC
    direction="column"
    gap="var(--spacing-5)"
    padding="var(--spacing-9)"
    style="max-width: 544px; margin: 0 auto"
  >
    <RouterLink :to="{ name: InboundFlowRoutes.RESIDENCE }">
      <ButtonQC wide>{{ 'Inbound' }}</ButtonQC>
    </RouterLink>

    <RouterLink :to="{ name: OutboundFlowRoutes.DESTINATION }">
      <ButtonQC wide>{{ 'OutBound' }}</ButtonQC>
    </RouterLink>
  </WrapperQC>
</template>
